<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.$store.commit('SET_THEME', this.$store.state.theme)
  }
}
</script>

<style>
:root {
  --primary: #264653;
  --primary-light: #e8eef0;
  --primary-hover: #1b333d;
  --text-on-primary: #ffffff;
  --menu-bg: #264653;
  --menu-text: #ffffff;
  --menu-active-text: #ffffff;
  --accent: #E9C46A;
  --secondary: #F4A261;
  --danger: #E76F51;
  --sidebar-bg: #ffffff;
  --sidebar-width: 220px;
  --sidebar-collapsed: 64px;
  --header-height: 60px;
  --body-bg: #f5f7fa;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 12px rgba(0,0,0,0.06);
  --radius: 10px;
}

[data-theme="verdigris"] {
  --primary: #2A9D8F;
  --primary-light: #e8f6f4;
  --primary-hover: #218c7f;
  --text-on-primary: #ffffff;
}

[data-theme="jasmine"] {
  --primary: #E9C46A;
  --primary-light: #fcf6e8;
  --primary-hover: #d9b55d;
  --text-on-primary: #3d3d3d;
}

[data-theme="sandy-brown"] {
  --primary: #F4A261;
  --primary-light: #fdf2e8;
  --primary-hover: #e08f4d;
  --text-on-primary: #3d3d3d;
}

[data-theme="burnt-peach"] {
  --primary: #E76F51;
  --primary-light: #fdf0ed;
  --primary-hover: #d25e42;
  --text-on-primary: #ffffff;
}

html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', 'Noto Sans SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-primary);
  background: var(--body-bg);
}

/* Element UI 全局覆盖 */
.el-card {
  border: none !important;
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow-sm) !important;
}
.el-card__header {
  border-bottom: 1px solid var(--border-color) !important;
  padding: 16px 20px !important;
  font-weight: 600;
  font-size: 15px;
  color: var(--text-primary);
}

/* Button */
.el-button--primary {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--text-on-primary) !important;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
.el-button--text {
  color: var(--primary) !important;
}
.el-button--text:hover {
  color: var(--primary-hover) !important;
}

/* Input & Textarea */
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: var(--primary) !important;
}

/* Radio & Checkbox */
.el-radio__input.is-checked .el-radio__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-radio__input.is-checked + .el-radio__label,
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--primary) !important;
}

/* Select */
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary) !important;
}
.el-select-dropdown__item.selected {
  color: var(--primary) !important;
  font-weight: 700;
}

/* Pagination */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary) !important;
  color: var(--text-on-primary) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--primary) !important;
}

/* Tabs */
.el-tabs__active-bar {
  background-color: var(--primary) !important;
}
.el-tabs__item.is-active {
  color: var(--primary) !important;
}
.el-tabs__item:hover {
  color: var(--primary-hover) !important;
}

/* Loading */
.el-loading-spinner .path {
  stroke: var(--primary) !important;
}

/* Table */
.el-table th {
  background-color: #f8fafc !important;
  color: var(--text-secondary) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: var(--primary-light) !important;
}

/* DatePicker */
.el-date-table td.current:not(.disabled) span,
.el-date-table td.today span {
  background-color: var(--primary) !important;
  color: var(--text-on-primary) !important;
}

/* Dropdown active item */
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: var(--primary-light) !important;
  color: var(--primary) !important;
}

/* Tag / Badge */
.el-tag--primary,
.el-tag--success {
  background-color: var(--primary-light) !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}
.el-tag--warning {
  background-color: rgba(233, 196, 106, 0.15) !important;
  border-color: var(--accent) !important;
  color: #8f6d2a !important;
}
.el-tag--danger {
  background-color: rgba(231, 111, 81, 0.12) !important;
  border-color: var(--danger) !important;
  color: var(--danger) !important;
}
.el-badge__content {
  background-color: var(--danger) !important;
}

/* Switch */
.el-switch.is-checked .el-switch__core {
  border-color: var(--primary) !important;
  background-color: var(--primary) !important;
}

/* Slider */
.el-slider__bar {
  background-color: var(--primary) !important;
}
.el-slider__button {
  border-color: var(--primary) !important;
}

/* Progress */
.el-progress-bar__inner {
  background-color: var(--primary) !important;
}

/* Notification */
.el-notification__title {
  color: var(--primary) !important;
}

/* Message */
.el-message--success {
  background-color: var(--primary-light) !important;
  border-color: var(--primary) !important;
}
.el-message--success .el-message__content {
  color: var(--primary) !important;
}
.el-message--warning {
  background-color: rgba(233, 196, 106, 0.12) !important;
  border-color: var(--accent) !important;
}
.el-message--warning .el-message__content {
  color: #8f6d2a !important;
}
.el-message--error {
  background-color: rgba(231, 111, 81, 0.12) !important;
  border-color: var(--danger) !important;
}
.el-message--error .el-message__content {
  color: var(--danger) !important;
}
</style>
